/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosInstance } from 'axios';
import { fetchDatacenterPerformanceAPI } from 'kontrolEdge/components/DataCenter/requests/request';

interface BandwidthItem {
  time: string;
  value: number;
}

interface BandwidthUtilization {
  inbound: BandwidthItem[];
  outbound: BandwidthItem[];
  timeRange: string;
  interval: string;
  unit: string;
}

interface DatacenterPerformanceData {
  datacenterId: number;
  bandwidthUtilization: BandwidthUtilization;
  portA: {
    subId: string,
  },
  portB: {
    subId: string,
  }
}

// Extend the state to include new properties
interface DatacenterState {
  lag: any;
  performanceData: DatacenterPerformanceData | null;
  performanceLoading: boolean;
  performanceError: string | null;
  timeRange: string;
  interval: string;
}

const initialState: DatacenterState = {
  lag: null,
  performanceData: null,
  performanceLoading: false,
  performanceError: null,
  timeRange: '5m',
  interval: '5s',
};

const datacenterSlice = createSlice({
  name: 'datacenter',
  initialState,
  reducers: {
    setLag: (state, action: PayloadAction<any>) => {
      state.lag = action.payload;
    },
    clearLag: (state) => {
      state.lag = null;
    },
    // Reducers for updating filters
    setTimeRange: (state, action: PayloadAction<string>) => {
      state.timeRange = action.payload;
    },
    setInterval: (state, action: PayloadAction<string>) => {
      state.interval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDatacenterPerformance.pending, (state) => {
        state.performanceLoading = true;
        state.performanceError = null;
      })
      .addCase(fetchDatacenterPerformance.fulfilled, (state, action: PayloadAction<DatacenterPerformanceData>) => {
        state.performanceData = action.payload;
        state.performanceLoading = false;
      })
      .addCase(fetchDatacenterPerformance.rejected, (state, action) => {
        state.performanceLoading = false;
        state.performanceError = action.payload as string;
      })
    }
    
});

export const fetchDatacenterPerformance = createAsyncThunk<
DatacenterPerformanceData,
  { api: AxiosInstance; datacenterId: string, timeRange: string; interval: string, tenantId: number },
  { rejectValue: string }
>(
  'internet/fetchPerformance',
  async ({ api, datacenterId, timeRange, interval,tenantId }, { rejectWithValue }) => {
    try {
      const response = await fetchDatacenterPerformanceAPI(api, datacenterId, timeRange, interval,tenantId);
      return response.data.data as DatacenterPerformanceData;
    } catch (err) {
      console.error("Error fetching performance data", err);
      return rejectWithValue("Failed to fetch performance data");
    }
  }
);

export const { setLag, clearLag, setInterval, setTimeRange } = datacenterSlice.actions;
export default datacenterSlice.reducer;